//reviewerScoreRecordTable
import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

export default function reviewerScoreRecordTable(props){
    let reviewerObjects = [];

    props.rubrics.map(rubric=>{
        reviewerObjects.push({
            criteriaTitle: rubric.criteria_title,
            scores: [],
        })
    })

    props.reviewers.map((reviewer,index)=>{
        let artifactObject = reviewer.artifactScores.filter(artifact => artifact.artifact_id == props.artifactId)
        let artifact = artifactObject[0];

        if(artifact){
            artifact.rubricScores.map((score,index)=>{
                if(score>=0) {
                    reviewerObjects[index].scores.push(score)
                }else if(score<0){
                    reviewerObjects[index].scores.push('NA')
                }
            })
        }else{
            reviewerObjects.map(reviewerObject=>{
                reviewerObject.scores[index]=null;
            })
        }
    })

    const getScoreTotals= function(){
        let summedArray;
        let combinedScores = [];
        if(reviewerObjects&&reviewerObjects.length>0){
            if(reviewerObjects[0].scores&&reviewerObjects[0].scores.length>0)
                reviewerObjects.map(revObj=>{
                    combinedScores.push(revObj.scores)
                })
        }

        if(combinedScores.length>0){
            summedArray = combinedScores.reduce(function(array1, array2) {
                return array1.map(function(value, index) {
                    if(array2[index]==null){
                        array2[index]='';
                    }
                    if(array2[index]=='NA'){
                        array2[index] = 0;
                    }
                    return value + array2[index];
                });
            });
        }
        return summedArray;
    }

    return(

        <Paper>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell></TableCell>
                        {props.reviewers.map(reviewer=>(
                            <TableCell align="center">{reviewer.display_name}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {reviewerObjects.map((scoreRow) => (
                        <TableRow key={scoreRow.criteriaTitle}>
                            <TableCell component="th" scope="row">
                                {scoreRow.criteriaTitle}
                            </TableCell>
                            {scoreRow.scores.map((score)=>(
                                <TableCell align="center">{score}</TableCell>
                            ))}
                        </TableRow>
                    ))}
                    <TableRow>
                        <TableCell>
                            Total Score
                        </TableCell>
                        {getScoreTotals().map(sum=>(
                            <TableCell align="center">
                                {sum!='null'?sum:''}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableBody>
            </Table>
        </Paper>
    )
}